import React from "react";
import { Calendar, Phone, Mail, MapPin, Hash } from "lucide-react";

export default function PatientInfoCard({ patient }) {
  return (
    <div className="bg-white border border-stone-200 rounded-xl shadow-soft p-6" data-testid="patient-info-card">
      <div className="flex items-center gap-3">
        <div className="w-14 h-14 rounded-full bg-brand-100 text-brand-700 font-display font-bold text-xl flex items-center justify-center">
          {patient.first_name?.[0]}{patient.last_name?.[0]}
        </div>
        <div>
          <h2 className="font-display text-xl font-bold text-stone-900">{patient.first_name} {patient.last_name}</h2>
          <div className="text-sm text-stone-500">{patient.mrn}</div>
        </div>
      </div>
      <div className="mt-5 space-y-2 text-sm">
        <div className="flex items-center gap-2 text-stone-600"><Hash className="w-4 h-4 text-stone-400" />{patient.mrn}</div>
        {patient.email && <div className="flex items-center gap-2 text-stone-600"><Mail className="w-4 h-4 text-stone-400" />{patient.email}</div>}
        {patient.phone && <div className="flex items-center gap-2 text-stone-600"><Phone className="w-4 h-4 text-stone-400" />{patient.phone}</div>}
        {patient.dob && <div className="flex items-center gap-2 text-stone-600"><Calendar className="w-4 h-4 text-stone-400" />Born {patient.dob}</div>}
        {patient.address && (
          <div className="flex items-start gap-2 text-stone-600">
            <MapPin className="w-4 h-4 text-stone-400 mt-0.5 shrink-0" />
            <span>
              {patient.address}
              {(patient.city || patient.state || patient.zip) && (
                <><br/><span className="text-stone-500">{[patient.city, patient.state, patient.zip].filter(Boolean).join(", ")}</span></>
              )}
            </span>
          </div>
        )}
        {!patient.address && (patient.city || patient.state || patient.zip) && (
          <div className="flex items-center gap-2 text-stone-600">
            <MapPin className="w-4 h-4 text-stone-400" />{[patient.city, patient.state, patient.zip].filter(Boolean).join(", ")}
          </div>
        )}
      </div>
    </div>
  );
}
